var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208,
    height: 173,
    viewBox: "0 0 208 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10487",
    "data-name": "Rectangle 10487",
    width: 208,
    height: 173,
    transform: "translate(230 2965)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10480",
    "data-name": "Rectangle 10480",
    width: 140,
    height: 140,
    transform: "translate(230 1855.847)",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87724",
    "data-name": "Mask Group 87724",
    transform: "translate(-230 -2965)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88196",
    "data-name": "Group 88196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9900",
    "data-name": "Path 9900",
    d: "M2387.013-2206.844c32.487-33.691,83.894-39.9,123.54-18.405s69.3,68.939,61.6,106.725-44.221,44.017-92.109,51.027-82.163.414-99.444-22.987S2354.525-2173.153,2387.013-2206.844Z",
    transform: "translate(-2135.255 5202.842)",
    fill: "#f0ffc6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87723",
    "data-name": "Mask Group 87723",
    transform: "translate(30 1129.153)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-product-5586753",
    transform: "translate(234.963 1856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9901",
    "data-name": "Path 9901",
    d: "M123.92,57.478a2.252,2.252,0,1,1,1.953,4.057L115.5,66.525a2.252,2.252,0,1,1-1.953-4.057ZM68.589,61.506a2.252,2.252,0,0,1,1.953-4.057l10.369,4.989a2.252,2.252,0,0,1-1.953,4.057Zm26.389-20.5a2.254,2.254,0,0,1,4.508,0V54.353a2.254,2.254,0,0,1-4.508,0ZM99.125,8.1l4.418,6.823,7.875,2.1a2.27,2.27,0,0,1,1.112,3.7l-5.08,6.252.451,8.145a2.271,2.271,0,0,1-3.156,2.194L97.2,34.4l-7.634,2.916A2.252,2.252,0,0,1,86.5,35.088l.421-8.145L81.783,20.6a2.286,2.286,0,0,1,1.172-3.606l7.875-2.1,4.448-6.852a2.317,2.317,0,0,1,3.848.059Zm1.142,10.009-3.035-4.688-2.976,4.6A2.237,2.237,0,0,1,92.9,19.038l-5.38,1.442,3.457,4.268a2.288,2.288,0,0,1,.541,1.593l-.3,5.56,5.2-2.013a2.317,2.317,0,0,1,1.623,0l5.2,2.013-.3-5.56a2.258,2.258,0,0,1,.511-1.533l3.517-4.3-5.38-1.442a2.258,2.258,0,0,1-1.323-.962ZM49.986,37.34,54.4,44.163l7.875,2.1a2.247,2.247,0,0,1,1.112,3.666l-5.049,6.281.421,8.175a2.233,2.233,0,0,1-3.125,2.164l-7.544-2.916L40.46,66.584a2.263,2.263,0,0,1-3.065-2.224l.421-8.175-5.14-6.341a2.282,2.282,0,0,1,1.172-3.606l7.875-2.1,4.448-6.852a2.287,2.287,0,0,1,3.816.06Zm1.143,10.009L48.093,42.69l-2.976,4.6a2.132,2.132,0,0,1-1.353,1.022l-5.38,1.442,3.457,4.268a2.239,2.239,0,0,1,.541,1.593l-.3,5.56,5.2-2.013a2.317,2.317,0,0,1,1.623,0l5.2,2.013-.3-5.56a2.258,2.258,0,0,1,.511-1.533l3.517-4.328-5.38-1.442a2.35,2.35,0,0,1-1.323-.962ZM148.264,37.34l4.418,6.823,7.9,2.1a2.259,2.259,0,0,1,1.112,3.666l-5.109,6.281.451,8.175a2.256,2.256,0,0,1-3.156,2.164l-7.544-2.916-7.634,2.946a2.272,2.272,0,0,1-3.065-2.224l.421-8.175-5.14-6.341a2.256,2.256,0,0,1,1.172-3.606l7.875-2.1,4.448-6.852a2.316,2.316,0,0,1,3.847.06Zm1.113,10.009-3.035-4.659-2.976,4.6a2.192,2.192,0,0,1-1.382,1.022l-5.38,1.442,3.457,4.268a2.24,2.24,0,0,1,.541,1.593l-.3,5.56,5.2-2.013a2.317,2.317,0,0,1,1.623,0l5.2,2.013-.3-5.56a2.258,2.258,0,0,1,.511-1.533l3.517-4.328-5.38-1.442a2.5,2.5,0,0,1-1.293-.962ZM125.844,84.437,97.23,77.375,68.616,84.408,97.23,91.441ZM97.772,72.9l37.989,9.347a2.4,2.4,0,0,1,1.442,1.022l14.636,21.759a2.232,2.232,0,0,1-1.263,3.517L137.5,111.787V135.26a2.275,2.275,0,0,1-1.713,2.194l-37.868,9.317a2.112,2.112,0,0,1-1.382,0l-37.868-9.317a2.274,2.274,0,0,1-1.713-2.194V111.787l-13.074-3.216a2.233,2.233,0,0,1-1.263-3.517c1.894-2.645,14.427-21.609,15-22.18l1.112-.6L96.69,72.926a1.883,1.883,0,0,1,1.081-.03Zm36.486,14.1L100.9,95.2l12.082,18,33.39-8.235ZM133,112.9l-20.468,5.049a2.249,2.249,0,0,1-2.4-.931l-10.64-15.839V141.75L133,133.486ZM94.978,101.147l-10.64,15.839a2.267,2.267,0,0,1-2.4.931L61.466,112.9v20.587l33.511,8.235ZM93.565,95.2l-33.39-8.205L48.093,104.965l33.36,8.235Z",
    transform: "translate(-32.185 -7.041)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/Free.caf42c6554c6239a5f39d8d68855ec68.svg";
export { ForwardRef as ReactComponent };